// extracted by mini-css-extract-plugin
export var ctaLinkArrow = "index-module--ctaLinkArrow--0HHg-";
export var valueAltDisplay = "index-module--valueAltDisplay--SUwrf";
export var valueColumn = "index-module--valueColumn--cfI+d";
export var valueColumnContainer = "index-module--valueColumnContainer--Ezzbm";
export var valueDark = "index-module--valueDark--wrkRN";
export var valueFourColumns = "index-module--valueFourColumns--byW4N";
export var valueHeadingContainer = "index-module--valueHeadingContainer--LATcV";
export var valueImageContainer = "index-module--valueImageContainer--MQba8";
export var valueInnerContainer = "index-module--valueInnerContainer--1-3pO";
export var valueNormalImageContainer = "index-module--valueNormalImageContainer--6C09M";
export var valueOuterContainer = "index-module--valueOuterContainer--WnDY+";
export var valueTextContainer = "index-module--valueTextContainer--So7Bn";